var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUpFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8408 4.38826C14.9269 3.09577 13.9018 2 12.6064 2C12.2402 2 11.9108 2.22299 11.7748 2.56306L9.2249 8.93775C9.08907 9.27733 8.76018 9.5 8.39444 9.5C7.90045 9.5 7.5 9.90045 7.5 10.3944V18.9C7.5 19.4601 7.5 19.7401 7.60899 19.954C7.70487 20.1422 7.85785 20.2951 8.04601 20.391C8.25992 20.5 8.53995 20.5 9.1 20.5H16.4448C17.539 20.5 18.0861 20.5 18.5441 20.311C18.9484 20.1442 19.3018 19.8742 19.5691 19.5281C19.872 19.1359 20.016 18.6081 20.3039 17.5525L21.3976 13.542C21.7724 12.1678 21.9598 11.4807 21.8009 10.9379C21.6617 10.4625 21.3509 10.0556 20.9288 9.79612C20.447 9.5 19.7348 9.5 18.3104 9.5H15.3551C15.0578 9.5 14.9091 9.5 14.7986 9.44088C14.7015 9.38893 14.6242 9.30636 14.5788 9.206C14.5272 9.0918 14.5371 8.94346 14.5569 8.64678L14.8408 4.38826Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 9.44772 2.94772 9 3.5 9C4.05228 9 4.5 9.44772 4.5 10V20C4.5 20.5523 4.05228 21 3.5 21C2.94772 21 2.5 20.5523 2.5 20L2.5 10Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpFilled);
export default __webpack_public_path__ + "static/media/thumb-up-filled.22f0dad803c0c8ccdace09cf9449804b.svg";
export { ForwardRef as ReactComponent };